import { AbstractCreateDto, AbstractUpdateDto } from '@/models/abstract-dto';
import { CrmEntity } from '@/models/base';

export abstract class AbstractMapper<T extends CrmEntity> {
    public abstract toCreateDto(entity: T): AbstractCreateDto;
    public abstract toUpdateDto(entity: T): AbstractUpdateDto;
}
